const emergencyOverlay = document.querySelector('.emergency-overlay');
const emergencyOverlayItems = document.querySelectorAll('.emergency-overlay__item');

if (emergencyOverlayItems.length > 0) {
    const closeAllEmergencyOverlayItems = () => {
        emergencyOverlayItems.forEach(overlay => {
            if (overlay.getAttribute('data-visible') == 'false') return;

            const hideEmergencyOverlayText = () => {
                overlay.querySelector('.emergency-overlay__text-container').hidden = true;
                overlay.removeEventListener('transitionend', hideEmergencyOverlayText);
            };

            overlay.setAttribute('data-visible', 'false');
            overlay
                .querySelector('.emergency-overlay__button')
                .setAttribute('aria-expanded', 'false');
            overlay.addEventListener('transitionend', hideEmergencyOverlayText);
        });
    };

    emergencyOverlayItems.forEach(overlay => {
        overlay.querySelector('.emergency-overlay__button').addEventListener('click', () => {
            const overlayIsOpen = overlay.getAttribute('data-visible') === 'true';
            closeAllEmergencyOverlayItems();

            if (!overlayIsOpen) {
                overlay.setAttribute('data-visible', 'true');
                overlay
                    .querySelector('.emergency-overlay__button')
                    .setAttribute('aria-expanded', 'true');
                overlay.querySelector('.emergency-overlay__text-container').hidden = false;
            }
        });
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            closeAllEmergencyOverlayItems();
        }
    });

    document.addEventListener('click', e => {
        if (!emergencyOverlay.contains(e.target)) {
            closeAllEmergencyOverlayItems();
        }
    });
}
